import { render, staticRenderFns } from "./realEstateAreas.vue?vue&type=template&id=62c242c5&"
import script from "./realEstateAreas.vue?vue&type=script&lang=js&"
export * from "./realEstateAreas.vue?vue&type=script&lang=js&"
import style0 from "./realEstateAreas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports